import { Injectable } from '@angular/core'

import { AuthService } from '../../auth/auth.service'
import { Notification } from '../shared/notification.model'

import { DialogService } from '../../dialog/shared/dialog.service'

import { environment } from '../../../environments/environment'

import { Observable } from 'rxjs/Observable'
import * as firebase from 'firebase'

@Injectable()
export class NotificationService {

  private messaging: firebase.messaging.Messaging
  private emitter: Observable<Notification>

  private firebaseRef = firebase.database().ref(environment.firebaseRoot)

  private readonly permissionEnabledItem = 'permission_enabled'

  constructor(private authService: AuthService,
    private dialogService: DialogService) {
    this.messaging = firebase.messaging()

    this.messaging.onTokenRefresh(() => {
      console.log('token refreshed')
      this.messaging.getToken()
        .then((token: string) => {
          this.setTokenSentToServer(false)
          this.sendTokenToServer(token)
        })
        .catch((err: Error) => {
          console.error('An error occured while retrieving token. ', err)
          this.setTokenSentToServer(false)
        })
    })

    this.emitter = new Observable<any>(observer => {
      this.messaging.onMessage((payload: any) => {
        console.log(payload)
        const notification: Notification = {
          chatId: payload.data.chatId,
          title: payload.data.title,
          image: payload.data.image,
          body: payload.data.body,
          userId: payload.data.srcId
        }

        observer.next(notification)
      })
    })
  }

  public showPermissionDialog() {
    if (this.getPermissionEnabled() === false && this.authService.currentUser) {
      this.dialogService
        .confirm('Accepter les notifications', 'Accepter les notifications pour ne manquer aucune invitation au cinéma.')
        .subscribe((result: boolean) => {
          if (result) {
            this.requestPermission()
            this.setPermissionEnabled(true)
          } else {
            this.setPermissionEnabled(false)

          }
        })
    } else if (this.getPermissionEnabled() === true && this.authService.currentUser) {
      this.requestPermission()
    }
  }

  // public setRequestPermissionAsked(flag: boolean = true) {
  //   window.localStorage.setItem('')
  // }

  public notify(senderUid: string, targetUid: string, chatId: string, type: string = 'NEW_CHAT'): Promise<any> {
    return <Promise<any>>this.firebaseRef.child('queue/tasks').push().set({
      sourceId: senderUid,
      targetId: targetUid,
      chatID: chatId,
      type: type
    })
  }

  public getNotificationEmitter(): Observable<Notification> {
    return this.emitter
  }

  private requestPermission() {
    this.messaging.requestPermission()
      .then(() => {
        return this.messaging.getToken()
      })
      .then((token: string) => {
        if (token) {
          this.sendTokenToServer(token)
        } else {
          this.setTokenSentToServer(false)
        }
      })
      .catch((err: Error) => {
        console.error('An error occured while retrieving token. ', err)
        this.setTokenSentToServer(false)
      })
  }

  private setPermissionEnabled(flag: boolean) {
    window.localStorage.setItem(this.permissionEnabledItem, flag.toString())
  }

  private getPermissionEnabled(): boolean {
    return !!window.localStorage.getItem(this.permissionEnabledItem)
  }

  private sendTokenToServer(token: string) {

    // if (!this.isTokenSentToServer()) {
      const uid = this.authService.currentUser.uid

      const updates = {}
      updates[`/users/${uid}/token`] = token
      this.firebaseRef.update(updates)

      console.log(updates);


      this.setTokenSentToServer(true)
    // }
  }

  private isTokenSentToServer() {
    return window.localStorage.getItem('sentToServer') === '1'
  }

  private setTokenSentToServer(sent: boolean) {
    if (sent) {
      window.localStorage.setItem('sentToServer', '1')
    } else {
      window.localStorage.setItem('sentToServer', '0')
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/notification/shared/notification.service.ts